module.exports = __webpack_public_path__ + "img/listbg.24f65047.png";